/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntegrationSettings } from './IntegrationSettings';
import {
    IntegrationSettingsFromJSON,
    IntegrationSettingsFromJSONTyped,
    IntegrationSettingsToJSON,
} from './IntegrationSettings';

/**
 * 
 * @export
 * @interface FindOneIntegrationSettingsByFacilityId200Response
 */
export interface FindOneIntegrationSettingsByFacilityId200Response {
    /**
     * 
     * @type {IntegrationSettings}
     * @memberof FindOneIntegrationSettingsByFacilityId200Response
     */
    data?: IntegrationSettings;
}

/**
 * Check if a given object implements the FindOneIntegrationSettingsByFacilityId200Response interface.
 */
export function instanceOfFindOneIntegrationSettingsByFacilityId200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindOneIntegrationSettingsByFacilityId200ResponseFromJSON(json: any): FindOneIntegrationSettingsByFacilityId200Response {
    return FindOneIntegrationSettingsByFacilityId200ResponseFromJSONTyped(json, false);
}

export function FindOneIntegrationSettingsByFacilityId200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOneIntegrationSettingsByFacilityId200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : IntegrationSettingsFromJSON(json['data']),
    };
}

export function FindOneIntegrationSettingsByFacilityId200ResponseToJSON(value?: FindOneIntegrationSettingsByFacilityId200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': IntegrationSettingsToJSON(value.data),
    };
}

